// extracted by mini-css-extract-plugin
module.exports = {"footer":"styles_footer__3STrE","content":"styles_content__2ntcK","selectAll":"styles_selectAll__16ew8"};